import { CurrencyFieldProps, fieldTypes, NumericFieldProps, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { DepositApplicationReadDTO } from "@/types";

export interface AchOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface AchOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const AchOptInComplexField: FC<AchOptInComplexFieldProps> = (props) => {
  const achOptInComplexValue = props.complexFieldValue as AchOptInComplexValue;
  const readOnly = achOptInComplexValue?.readOnly || props.readOnly;

  return (
    <section className="complex-field-container ach-opt-in">
      <SectionHeader label={achOptInComplexValue?.headerLabel || props.label} hidden={!achOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.ACH_OPT_IN.IS_ACH_OPT_IN_ENABLED}
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
        {/* ACH conditional fields - show when enabled */}
        {props.formValue?.achOptIn?.isAchOptInEnabled && (
          <div className="opt-ins-form-v2__ach-fields">
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.ACH_OPT_IN.APPLICABLE_SEC_CODES_AS_LIST}
              complexFieldProps={{
                disabled: readOnly,
              }}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.ACH_OPT_IN.ACH_PURPOSES_AS_LIST}
              complexFieldProps={{
                disabled: readOnly,
              }}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.ACH_OPT_IN.ESTIMATED_QUANTITY_OF_ACH_TRANSACTIONS_PER_MONTH
              }
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false,
                format: "n0"
              } as NumericFieldProps}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.ACH_OPT_IN.MAXIMUM_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY
              }
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false
              } as CurrencyFieldProps}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={
                COMPLEX_FIELD_KEYS.ACH_OPT_IN.AVERAGE_DOLLAR_AMOUNT_OF_ACH_TRANSACTIONS_PER_DAY
              }
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false
              } as CurrencyFieldProps}
            />
            <FieldComplexV2
              {...props}
              complexFieldKey={COMPLEX_FIELD_KEYS.ACH_OPT_IN.TOTAL_ACH_AMOUNT_IN_DOLLARS_PER_MONTH}
              complexFieldProps={{
                disabled: readOnly,
                showIncrementButtons: false
              } as CurrencyFieldProps}
            />
          </div>
        )}
      </div>
    </section>
  );
};
